module.exports = __webpack_public_path__ + "static/feature_reports-7801251a1410007ffdafcba4a16729c7.png";